import { SLOT_NAMES, slotOf } from './ticketDate';

const ptDay = (d) => new Date(d).toLocaleDateString('en-CA', { timeZone: 'America/Los_Angeles' });
const dayName = (d) => new Date(d).toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', month: 'short', day: 'numeric' });

// Games in start-time order, split by day and then Morning / Midday / Night so each ticket can stay in one window.
export const GamesBySlot = ({ games, render, testId = 'games-by-slot' }) => {
  const sorted = [...games].filter((g) => g.date).sort((a, b) => String(a.date).localeCompare(String(b.date)));
  const groups = [];
  sorted.forEach((g) => {
    const key = `${ptDay(g.date)}-${slotOf(g.date)}`;
    if (groups[groups.length - 1]?.key !== key) groups.push({ key, slot: slotOf(g.date), day: dayName(g.date), list: [] });
    groups[groups.length - 1].list.push(g);
  });
  const multiDay = new Set(groups.map((x) => x.day)).size > 1;
  return (
    <div className="space-y-3" data-testid={testId}>
      {groups.map((x) => (
        <section key={x.key} className="space-y-2" data-testid={`${testId}-${x.slot}`}>
          <p className="px-1 text-xs font-bold uppercase tracking-wide text-amber-300">{multiDay ? `${x.day} · ` : ''}{SLOT_NAMES[x.slot]} · {x.list.length} game{x.list.length === 1 ? '' : 's'}</p>
          {x.list.map(render)}
        </section>
      ))}
    </div>
  );
};
